// services/contactService.js

import { PART_API_BASE_URLS } from '../config/api-constants/index';
import { API_BASE_URL } from '../config/setting/index';

export const envoyerMessage = async (formData) => {
  const response = await fetch(API_BASE_URL + PART_API_BASE_URLS.Contact, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });

  if (!response.ok) throw new Error('Erreur lors de l’envoi du message');
  return await response.json();
};
